// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2C6j1","row":"Node_row__G-RRD","label":"Node_label__2ipUp","footer":"Node_footer__17iRr"};